import { Fragment, ReactElement, RefObject, useEffect, useReducer } from 'react';
import { createPortal } from 'react-dom';

type PortalProps<T> = (
  | {
      containerRef?: RefObject<T>;
      containerQuerySelector?: never;
    }
  | {
      containerQuerySelector?: string;
      containerRef?: never;
    }
) & {
  children?: ReactElement;
};

const Portal = <T extends Element>({ children, containerRef, containerQuerySelector }: PortalProps<T>) => {
  const [refreshKey, incrementRefreshKey] = useReducer((x: number) => x + 1, 0);

  // HACK: re-render when containerRef.current or document.QuerySelector resolves
  useEffect(incrementRefreshKey, [incrementRefreshKey]);

  const maybeQuerySelectorElement = containerQuerySelector
    ? document.querySelector(containerQuerySelector)
    : null;

  // if either containerQuerySelector or containerRef are passed, wait until they resolve
  if ((containerQuerySelector && !maybeQuerySelectorElement) || (containerRef && !containerRef?.current))
    return null;

  return createPortal(
    <Fragment key={refreshKey}>{children}</Fragment>,
    maybeQuerySelectorElement ?? containerRef?.current ?? document.body,
  );
};
export default Portal;
